import { httpClient } from '../../../shared/api/httpClient';
import { TicketCategory } from '../../ticket/model/types';

export async function getCategories(site?: string): Promise<TicketCategory[]> {
  const params = new URLSearchParams();
  if (site) {
    params.append('site', site);
  }
  
  return httpClient.get<TicketCategory[]>(`/categories/?${params.toString()}`);
}

export async function getCategoryById(id: string): Promise<TicketCategory | null> {
  try {
    return await httpClient.get<TicketCategory>(`/categories/${id}/`);
  } catch (error) {
    return null;
  }
}

export async function createCategory(data: {
  name: string;
  site: string;
  parentId?: string;
}): Promise<TicketCategory> {
  return httpClient.post<TicketCategory>('/categories/', {
    name: data.name,
    site: data.site,
    parentId: data.parentId,
  });
}

export async function updateCategory(id: string, data: Partial<TicketCategory>): Promise<TicketCategory> {
  return httpClient.put<TicketCategory>(`/categories/${id}/`, {
    name: data.name,
    site: data.site,
    parentId: data.parentId,
  });
}

export async function deleteCategory(id: string): Promise<void> {
  return httpClient.delete(`/categories/${id}/`);
}

